// Toggles sound on the video inside the closest [data-sound-scope]; labels come from Liquid translations.
class SSoundToggle extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.button = this.querySelector('button');
    this.label = this.querySelector('[data-sound-label]');
    this.video = this.closest('[data-sound-scope]')?.querySelector('video');
    if (!this.button || !this.video) return;
    this.#controller = new AbortController();
    this.button.addEventListener('click', () => this.#toggle(), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #toggle() {
    const enable = this.video.muted;
    this.video.muted = !enable;
    if (enable) this.video.play().catch(() => {});
    this.button.setAttribute('aria-pressed', String(enable));
    if (this.label) this.label.textContent = enable ? this.dataset.labelOff : this.dataset.labelOn;
  }
}

if (!customElements.get('s-sound-toggle')) customElements.define('s-sound-toggle', SSoundToggle);
